export default __webpack_public_path__ + "static/media/circle-plus-colored.44151d69.svg";